import { css } from 'styled-components';

export const themeTokens = {
  checkoutTemplate: {
    wrapper: css`
      background: ${({ theme }) => theme.colors.palette.marble};
    `,
  },
};
